import { HelpPreference } from '@/autogenerated/@prisma/prisma-mongo-client';
import Icon from '@/components/ui/Icon';
import { helpPreferences } from '@/constants/helpPreferences';
import { cn } from '@/lib/utils';

function HelpPreferenceTag({
  type,
  showIcon = true,
}: {
  type: HelpPreference;
  showIcon?: boolean;
}) {
  const { value, iconVariant, lightColor } = helpPreferences.find(
    (option) => option.value === type
  )!;

  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-l-[2px] rounded-r-full border-l-8 py-1 pr-3 pl-1 text-xs shadow`}
      style={{ borderColor: `hsl(var(--${lightColor}))` }}
    >
      {showIcon && <Icon variant={iconVariant} width={16} height={16} />}
      {value.charAt(0).toUpperCase() + value.slice(1)}
    </div>
  );
}

export default function HelpPreferenceTags({
  types,
  className,
}: {
  types: HelpPreference[];
  className?: string;
}) {
  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {types.map((type) => (
        <HelpPreferenceTag key={type} type={type} showIcon={false} />
      ))}
    </div>
  );
}
